import type { Vault } from '@/types/vault'
import { DAY_IN_SECONDS } from '@vaultsfyi/common/constants'

export const NOT_RATED_LABEL = 'NOT RATED'
export const NOT_RATED_REASON =
  'This vault is too new or missing one or more required score components, so we do not show an overall Reputation Score yet.'

const MIN_RATED_VAULT_AGE_DAYS = 90
const MIN_RATED_VAULT_AGE_SECONDS = MIN_RATED_VAULT_AGE_DAYS * DAY_IN_SECONDS

type VaultWithCreationData = Vault & {
  creationData?: {
    deploymentTimestamp?: number | null
  } | null
}

export function shouldShowNotRatedReputation(vault: Vault, nowTimestamp = Math.floor(Date.now() / 1000)) {
  const score = vault.score

  if (!score) {
    return true
  }

  const deploymentTimestamp = (vault as VaultWithCreationData).creationData?.deploymentTimestamp
  if (typeof deploymentTimestamp !== 'number' || deploymentTimestamp <= 0) {
    return true
  }

  const vaultAgeSeconds = nowTimestamp - deploymentTimestamp
  if (vaultAgeSeconds < MIN_RATED_VAULT_AGE_SECONDS) {
    return true
  }

  if (score.holderScore === null || score.holderScore <= 0) {
    return true
  }

  return false
}
